import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import { LocalStorage } from '~/web-frontend-core/base/LocalStorage';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
const LS_KEY = '~/web-frontend-core/store/line/matchesList/Championships';
/** Состояния чемпионатов */
export class ChampionshipsStates extends Subscribtion {
    constructor() {
        super(...arguments);
        this.foldedChampionships = new Set();
        this.favoriteChampionships = new Set(LocalStorage.restore(LS_KEY) || []);
        this.data = {};
        this._onFavorite = () => void 0;
        //#region fold
        this.isFoldedChampionship = (championchipID) => this.foldedChampionships.has(championchipID);
        this.foldChampionship = (championchipID, isFolded) => {
            isFolded ?
                this.foldedChampionships.add(championchipID) :
                this.foldedChampionships.delete(championchipID);
            this.notify(championchipID);
        };
        //#endregion
        //#region favorite
        this.isFavoriteChampionship = (championshipID) => this.favoriteChampionships.has(championshipID);
        this.favoriteChampionship = (championshipID, isFavorite) => {
            isFavorite ?
                this.favoriteChampionships.add(championshipID) :
                this.favoriteChampionships.delete(championshipID);
            this.store();
            this._onFavorite(championshipID, this.data[championshipID].sortedMatchIds, isFavorite);
            this.notify();
        };
    }
    getData(filter) {
        if (filter && filter.isFavorite) {
            const favoriteChampIDs = Array.from(this.favoriteChampionships.values());
            return objectFromEntries(favoriteChampIDs.map((champID) => [champID, this.data[champID]]));
        }
        return this.data;
    }
    update(data) {
        objectEntries(data).forEach(([championchipID, championship]) => {
            this.data[championchipID] = Object.assign(this.data[championchipID] || {}, championship);
            if (championship.sortedMatchIds) {
                this.data[championchipID].sortedMatchIds = championship.sortedMatchIds;
            }
        });
    }
    clear() {
        this.data = {};
        this.foldedChampionships.clear();
        this.favoriteChampionships.clear();
        this.store();
    }
    isAllUnfolded() {
        return this.foldedChampionships.size === 0;
    }
    unfoldAll() {
        this.foldedChampionships.clear();
    }
    foldAll() {
        this.foldedChampionships = new Set(Object.keys(this.data).map(Number));
    }
    setFavorite(championchipIDs) {
        this.favoriteChampionships = new Set(championchipIDs);
    }
    onFavorite(callback) {
        this._onFavorite = callback;
    }
    //#endregion
    store() {
        LocalStorage.store(LS_KEY, Array.from(this.favoriteChampionships.values()));
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/matchesList/Championships.js